import { Outlet } from "react-router-dom";
type Props = {};

const UserManagement = (props: Props) => {
  return <Outlet />;
};
export default UserManagement;
